<div class="contact">
  <div class="list" >
    <div class="list__header">
      <p>Contactanos</p>
    </div>
    <div class="list--contact">
      <div>
        <ul>
          <li class="event" *ngIf="globalService.website.direction">
            <a>
              <!-- OK -->
              <app-icon icon="home" class="icon"> </app-icon>
              {{ globalService.website.direction }}
            </a>
          </li>
          <li class="event numbers" *ngIf="globalService.website.phone">
            <a
              (click)="click('call')"
              [href]="'tel:' + globalService.website.phone"
            >
              <!-- OK -->
              <app-icon icon="phone" class="icon"> </app-icon>
              {{ globalService.website.phone }}
            </a>
          </li>
          <li class="event" *ngIf="globalService.website.email">
            <a
              (click)="click('mail')"
              [href]="'mailto:' + globalService.website.email"
            >
              <!-- OK -->
              <app-icon icon="mail" class="icon"> </app-icon>
              {{ globalService.website.email }}
            </a>
          </li>

        </ul>
      </div>
    </div>
    <div
      class="afip"
      *ngIf="globalService.options.datafiscal.status"
      [innerHTML]="
        globalService.options.datafiscal.data.datafiscal_codigo
          | safeHtml
      "
    ></div>
  </div>
</div>
